// Б.2.b: Удар электро-кнутом (syn_udar_elektro_knutom, action, common).
//
// Цель: один юнит на поле (свой ИЛИ вражеский). Героев нельзя выбрать никогда.
// Скрытные вражеские юниты недоступны как цель. Если у врага есть Провокация —
// выбор сужается до taunt-юнитов врага. На свои юниты Провокация не влияет.
//
// Эффект:
//   - Цель получает 2 ПРОБИВАЮЩЕГО урона (броня игнорируется и для своих,
//     и для вражеских юнитов). Б.2.b-fix1 (Баг 2).
//   - Если цель — свой юнит, дополнительно +3/0/0 (текущая атака +3) до конца
//     игры. Бафф выдаётся ДО урона — если цель умрёт от 2 урона, Посмертие
//     активируется как обычно (но бонус атаки уже не доедет до битвы).

import { applyDamage } from '../../combat.js';
import { hasKeyword, KW } from '../../keywords.js';
import { onUnitDamaged, onUnitDied } from '../deus/index.js';

export const CARD_ID = 'syn_act_elektroknut';

// Пул целей. playerIdx — кто разыгрывает.
export function getTargets(state, playerIdx) {
  const me    = state.players[playerIdx];
  const enemy = state.players[1 - playerIdx];
  const out = [];
  // Свои живые юниты — все, без ограничения по taunt/stealth.
  for (const u of me.unitsOnField()) out.push(u);
  // Вражеские: учитываем Провокацию и Скрытность.
  const enemyUnits = enemy.unitsOnField();
  const enemyTaunts = enemyUnits.filter(u => hasKeyword(u, KW.TAUNT));
  if (enemyTaunts.length > 0) {
    for (const u of enemyTaunts) out.push(u);
  } else {
    for (const u of enemyUnits) {
      if (hasKeyword(u, KW.STEALTH)) continue;
      out.push(u);
    }
  }
  return out;
}

export function resolveUdar(state, playerIdx, targetCard) {
  const p = state.players[playerIdx];
  if (!targetCard || !targetCard.isAlive() || targetCard.type !== 'unit') {
    state.log.add(`⚡ ${p.name}: Удар электро-кнутом — цель недоступна`);
    return { ok: false, reason: 'invalid_target' };
  }
  const targetOwnerIdx = targetCard.ownerId;
  const ownerName = state.players[targetOwnerIdx]?.name || '?';
  const isAlly = targetOwnerIdx === playerIdx;
  // Бафф своему юниту до урона — чтобы при смерти Посмертие активировалось
  // на «уже усиленном» юните (важно семантически, для тестов на лог-цепочки).
  if (isAlly) {
    const beforeAtk = targetCard.current.atk;
    targetCard.current.atk += 3;
    state.log.add(`⚡ ${p.name}: Удар электро-кнутом → ${targetCard.name_ru}: +3/0/0 (atk ${beforeAtk}→${targetCard.current.atk})`);
  }
  // 2 урона через applyDamage. Б.2.b-fix1 (Баг 2): pierce:true — броня
  // игнорируется и для своих, и для вражеских юнитов.
  const before = { hp: targetCard.current.hp, armor: targetCard.current.armor };
  const r = applyDamage(targetCard, 2, { pierce: true });
  const taken = (r.armorAbsorbed || 0) + (r.hpLost || 0);
  state.log.add(
    `⚡ ${p.name}: Удар электро-кнутом → ${targetCard.name_ru} [${ownerName}]: 2 урона ` +
    `(HP ${before.hp}→${targetCard.current.hp}, броня ${before.armor}→${targetCard.current.armor})`
  );
  if (taken > 0) {
    onUnitDamaged(state, { ownerIdx: targetOwnerIdx, card: targetCard, dmg: taken });
  }
  if (targetCard.current.hp <= 0) {
    const owner = state.players[targetOwnerIdx];
    targetCard.alive = false;
    owner.removeFromField(targetCard);
    state.log.add(`✗ ${targetCard.name_ru} [${ownerName}] погибает`);
    onUnitDied(state, {
      ownerIdx: targetOwnerIdx, card: targetCard,
      killer: null, killerIdx: playerIdx, killerWasCounter: false
    });
  }
  return { ok: true };
}
